import React from 'react';
import Header from '../components/Header';
import CaseStudiesHero3 from '../components/CaseStudyThree/CaseStudiesHero3';
import CaseStudiesBeginning3 from '../components/CaseStudyThree/CaseStudiesBeginning3';
import CaseStudiesTesting3 from '../components/CaseStudyThree/CaseStudiesTesting3';
import CaseStudiesResults3 from '../components/CaseStudyThree/CaseStudiesResults3';
import CaseStudiesCallout3 from '../components/CaseStudyThree/CaseStudiesCallout3';
import '../styles/custom.css';

const CaseStudiesPageThree = () => {
  return (
    
    <div className="page-wrapper">
      <Header />
      <CaseStudiesHero3 />
      <CaseStudiesBeginning3 />
      <CaseStudiesTesting3 />
      <CaseStudiesResults3 />
      <CaseStudiesCallout3 />
    </div>
  );
}

export default CaseStudiesPageThree;